export default "__VITE_ASSET__XIWeMB2N__"